<template>
  <div class="membership">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('list.membership') }}
        </h3>
        <div class="box-tools">
          <template v-if="can([$Permissions.backend.setting.membership.store])">
            <router-link
              :to="{name: 'MembershipCreate'}"
              class="btn btn-primary btn-sm"
            >
              {{ $t('label.newMembership') }}
            </router-link>
          </template>
        </div>
      </div>
      <div class="box-body">
        <div>
          <table
            id="membership-table"
            class="table table-hover table-striped table-bordered"
          >
            <thead>
              <tr>
                <th>{{ $t('table.action') }}</th>
                <th>{{ $t('table.createdAt') }}</th>
                <th>{{ $t('table.color') }}</th>
                <th>{{ $t('table.khmerName') }}</th>
                <th>{{ $t('table.englishName') }}</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'List',
  metaInfo () {
    return {
      title: this.$t('string.membershipList'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  data () {
    return {
      oTable: null
    }
  },
  watch: {
    '$i18n.locale': function () {
      this.oTable.clear()
      this.oTable.destroy()
      this.oTable = this.refreshTable()
      this.oTable.draw(true)
      this.loadAction()
    }
  },
  methods: {
    refreshDataTable () {
      this.oTable.draw(true)
    },
    deleteMembership (uuid) {
      const self = this
      this.$swal({
        title: self.$t('string.areYouSure?'),
        text: self.$t('string.youWillNotBeAbleToRevertThis!'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: self.$t('string.yesDeleteIt'),
        cancelButtonText: self.$t('button.cancel')
      }).then((result) => {
        if (result.value) {
          this.$axios.post(process.env.VUE_APP_API + '/api/v1/membership/delete', {
            uuid: uuid
          }).then((response) => {
            if (response.data.code === 1) {
              this.refreshDataTable()
            }
            self.$swal(
              'Deleted!',
              'The request have been processed',
              'success'
            )
          })
        }
      })
    },
    refreshTable () {
      const self = this
      return $('#membership-table').DataTable({
        stateSave: true,
        processing: true,
        serverSide: true,
        scrollCollapse: true,
        pageLength: process.env.VUE_APP_PAGE_LENGTH,
        lengthMenu: this.$lengthMenu,
        ajax: {
          method: 'POST',
          url: process.env.VUE_APP_API + '/api/v1/membership',
          data: (d) => {
            d.labelShow = self.$t('label.show')
            d.labelEdit = self.$t('label.edit')
            d.labelDelete = self.$t('label.delete')
            d.noPermission = self.$t('string.noPermission')
          },
          error: (xhr) => {
            this.onAccessDenied(xhr)
          }
        },
        columns: [
          {
            data: 'action',
            name: 'action',
            searchable: false,
            orderable: false
          },
          {
            data: 'created_at',
            name: 'created_at',
            searchable: false
          },
          { data: 'color', name: 'color' },
          { data: 'name_km', name: 'name_km' },
          {
            data: 'name_en',
            name: 'name_en'
          }
        ],
        language: {
          url: `/locale/${this.$i18n.locale}.json`
        },
        order: [
          [1, 'desc']
        ]
      })
    },
    loadAction () {
      this.clearEventHandlers([
        '.membership-show',
        '.membership-edit',
        '.membership-delete'
      ])
      const self = this
      $(document).on('click', '.membership-show', function () {
        self.$router.push({
          name: 'MembershipShow',
          params: { uuid: $(this).attr('data-uuid') }
        })
      })
      $(document).on('click', '.membership-edit', function () {
        self.$router.push({
          name: 'MembershipEdit',
          params: { uuid: $(this).attr('data-uuid') }
        })
      })
      $(document).on('click', '.membership-delete', function () {
        self.deleteMembership($(this).attr('data-uuid'))
      })
    }
  },
  mounted () {
    this.oTable = this.refreshTable()
    this.loadAction()
  },
  beforeDestroy () {
    this.oTable.clear()
    this.oTable.destroy()
  }
}
</script>

<style scoped>

</style>
